// extracted by mini-css-extract-plugin
export default {"legalPage":"LegalPages_legalPage__625C8","backButton":"LegalPages_backButton__DJylA","content":"LegalPages_content__Bgo8M","widerrufFormular":"LegalPages_widerrufFormular__5PWha"};